import * as _ from 'lodash'
import * as React from 'react'

import EditInput from './editInput'
import { spaceAfter, startsWithPunctuationRegex } from './sharedRegexes'

import { WordObject } from '../../interfaces/proofreaderActivities'

interface ParagraphProps {
  words: Array<WordObject>;
  handleParagraphChange: Function;
  numberOfResets: number;
  underlineErrors: boolean;
  index: number;
}

export default class Paragraph extends React.PureComponent<ParagraphProps, {}> {
  constructor(props: ParagraphProps) {
    super(props)

    this.handleWordChange = this.handleWordChange.bind(this)
    this.renderInputFields = this.renderInputFields.bind(this)
  }

  // NB: This addresses the case where a comma insertion is inspected, but
  // the student inserts the comma directly before the proceeding word, causing
  // the commma to be improperly associated with the proceeding word
  // Example: "In 1965 ,the USSR..."
  redistributeLeadingPunctuation(text: string, wordIndex: number, words: Array<WordObject>) {
    const currentWord = words[wordIndex]
    const previousWord = wordIndex > 0 ? words[wordIndex - 1] : null

    // Check if text now starts with punctuation that should belong to the previous word
    const startsWithPunct = startsWithPunctuationRegex.test(text)
    const currentStartsWithPunct = startsWithPunctuationRegex.test(currentWord.currentText)

    // If punctuation was added at the beginning and there's a previous word
    if (startsWithPunct && !currentStartsWithPunct && previousWord) {
      const leadingPunctMatch = text.match(/^([.,#!;:=\-)]+)/)

      if (leadingPunctMatch) {
        const leadingPunct = leadingPunctMatch[1]
        const textWithoutLeadingPunct = text.substring(leadingPunct.length)

        const updatedWords = _.cloneDeep(words)
        updatedWords[wordIndex - 1]['currentText'] = previousWord.currentText + leadingPunct
        updatedWords[wordIndex]['currentText'] = textWithoutLeadingPunct

        return updatedWords
      }
    }

    return null
  }

  handleWordChange(text: string, i: number, editInput: any) {
    const { words, handleParagraphChange, index } = this.props

    // Try to redistribute leading punctuation to previous word
    const redistributedWords = this.redistributeLeadingPunctuation(text, i, words)

    if (redistributedWords) {
      handleParagraphChange(redistributedWords, index, editInput)
      return
    }

    // Normal case - just update the current word
    const newWords = _.cloneDeep(words)
    newWords[i]['currentText'] = text
    handleParagraphChange(newWords, index, editInput)
  }

  renderInputFields() {
    const { words, underlineErrors, numberOfResets, } = this.props
    let className = 'paragraph'
    if (!underlineErrors) {
      className += ' no-underline'
    }
    const inputs = words.map((word: WordObject, i: number) => {
      const nextWord = words[i + 1]
      return (
        <EditInput
          key={word.wordIndex}
          {...word}
          nextWordStartsWithPunctuation={!spaceAfter(word.currentText, nextWord?.currentText)}
          numberOfResets={numberOfResets}
          onWordChange={this.handleWordChange}
          underlineErrors={underlineErrors}
        />
      )})
    return <div className={className}>{inputs}</div>
  }

  render() {
    return this.renderInputFields()
  }
}
